import React, { useMemo } from 'react'
import { Html, Line } from '@react-three/drei'
import { const_var, params } from '../../../../../../redux/reducers/reducer'

const OutLineSection = () => {

    const camPosX = const_var.camera?.position?.x;

    let offset = 1
    if(camPosX >= 0) offset = 1;
    else if(camPosX < 0) offset = -1;

    const leftLinePoints = useMemo(() => (
        [
            [-(params.p_w / 2 + 0.33 ), 0.15, -(params.p_d / 2 - parseInt(params.p_u_t) - 0.1)],
            [(params.p_w / 2 + 0.33 ), 0.15, -(params.p_d / 2 - parseInt(params.p_u_t) - 0.1)],
            [(params.p_w / 2 + 0.33 ), params.p_h - 0.3, -(params.p_d / 2 - parseInt(params.p_u_t) - 0.1)],
            [-(params.p_w / 2 + 0.33 ), params.p_h -((params.singleSlope && params.freeStandingSide === 'left') ? params.p_w * params.p_r_p / 12 : 0) - 0.3, -(params.p_d / 2 - parseInt(params.p_u_t) - 0.1)],
            [-(params.p_w / 2 + 0.33 ), 0.15, -(params.p_d / 2 - parseInt(params.p_u_t) - 0.1)],
            [-(params.p_w / 2 + 0.33 ), 0.15, -(params.p_d / 2 + 0.4)],
            [-(params.p_w / 2 + 0.33 ), params.p_h -((params.singleSlope && params.freeStandingSide === 'left') ? params.p_w * params.p_r_p / 12 : 0) - 0.3, -(params.p_d / 2 + 0.4)],
            [-(params.p_w / 2 + 0.33 ), params.p_h -((params.singleSlope && params.freeStandingSide === 'left') ? params.p_w * params.p_r_p / 12 : 0) - 0.3, -(params.p_d / 2 - parseInt(params.p_u_t) - 0.1)],
            
        ]
    ), [params.p_d, params.p_u_t, params.p_w, params.p_h, params.p_r_p, params.singleSlope, params.freeStandingSide])

    const rightLinePoints = useMemo(() => (
        [
            [(params.p_w / 2 + 0.33 ), 0.15, -(params.p_d / 2 - parseInt(params.p_u_t) - 0.1)],
            [(params.p_w / 2 + 0.33 ), 0.15, -(params.p_d / 2 + 0.4)],
            [(params.p_w / 2 + 0.33 ), params.p_h - 0.3, -(params.p_d / 2 + 0.4)],
            [(params.p_w / 2 + 0.33 ), params.p_h - 0.3, -(params.p_d / 2 - parseInt(params.p_u_t) - 0.1)],
         
            
        ]
    ), [params.p_d, params.p_u_t, params.p_w, params.p_h])

    const backBottomLinePoints = useMemo(() => (
        [
            [(params.p_w / 2 + 0.33 ), 0.15, -(params.p_d / 2 + 0.4)],  
            [-(params.p_w / 2 + 0.33 ), 0.15, -(params.p_d / 2 + 0.4)],        
        ]
    ), [params.p_d, params.p_w])

    const backTopLinePoints = useMemo(() => (
        [
            [(params.p_w / 2 + 0.33 ), params.p_h - 0.3, -(params.p_d / 2 + 0.4)],  
            [-(params.p_w / 2 + 0.33 ), params.p_h -((params.singleSlope && params.freeStandingSide === 'left') ? params.p_w * params.p_r_p / 12 : 0) - 0.3, -(params.p_d / 2 + 0.4)],        
        ]
    ), [params.p_d, params.p_w, params.p_h, params.p_r_p, params.singleSlope, params.freeStandingSide])


    return (
        <group position={[0, 0, 0.1]}>
            <Line
                points={leftLinePoints}
                color="#00BE00"
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
            <Line
                points={rightLinePoints}
                color="#00BE00"
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
            <Line
                points={backBottomLinePoints}
                color="#00BE00"
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
            <Line
                points={backTopLinePoints}
                color="#00BE00"
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
            <Html position={[offset * params.p_w / 2, params.p_h, -(params.p_d - params.p_u_t )/ 2]} style={{ pointerEvents: 'none' }}>
                <span style={{backgroundColor: 'white', border: 'solid 2px #00BE00', color: 'black', borderRadius: '50%', cursor: 'pointer', display:'flex', alignItems: 'center', justifyContent: 'center', padding: '3px', userSelect: 'none', fontSize: 'smaller'}}>
                    <i className='icon-drag-ico'/>
                </span>
            </Html>
        </group>
    )
}

export default OutLineSection